import { render, staticRenderFns } from "./PortfolioOrderDetails.vue?vue&type=template&id=3f9d77cb&scoped=true"
import script from "./PortfolioOrderDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortfolioOrderDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PortfolioOrderDetails.vue?vue&type=style&index=0&id=3f9d77cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9d77cb",
  null
  
)

export default component.exports